const config = {
  MAS_TGC_UAT: '',
  singlePointLogin: '',
  appId: '',
  staffSelector: {},
  uEditor: {},
};
switch (process.env.VUE_APP_ENV) {
  case 'PROD':
    config.MAS_TGC = process.env.VUE_APP_MAS_TGC;
    config.singlePointLogin = process.env.VUE_APP_LOGIN_URL;
    config.staffSelector = {
      url: process.env.VUE_APP_STAFF_SELECTOR_URL,
      project: process.env.VUE_APP_STAFF_SELECTOR_PROJECT,
    };
    config.uEditor = {
      url: process.env.VUE_APP_UEDITOR_URL,
      project: process.env.VUE_APP_UEDITOR_PROJECT,
    };
    config.appId = process.env.VUE_APP_APPID;
    break;
  case 'SIT' || 'UAT':
    config.MAS_TGC = process.env.VUE_APP_MAS_TGC;
    config.singlePointLogin = process.env.VUE_APP_LOGIN_URL;
    config.staffSelector = {
      url: process.env.VUE_APP_STAFF_SELECTOR_URL,
      project: process.env.VUE_APP_STAFF_SELECTOR_PROJECT,
    };
    config.uEditor = {
      url: process.env.VUE_APP_UEDITOR_URL,
      project: process.env.VUE_APP_UEDITOR_PROJECT,
    };
    config.appId = process.env.VUE_APP_APPID;
    break;
  default:
    config.MAS_TGC = 'MAS_TGC_UAT';
    config.singlePointLogin = 'https://signinuat.midea.com/login?service=';
    config.staffSelector = {
      url: 'http://devcloud.midea.com/builder/m_staff_selector-V1.0.2/index.js',
      project: '/mframework',
    };
    config.uEditor = {
      // url: 'http://devcloud.midea.com/builder/uEditor-V1.0.3/index.js',
      url: 'http://devcloud.midea.com/builder/mff-ueditor-V1.0.0/index.js',
      project: '/mframework',
    };
    config.appId = 'SRM_SUPER';
    break;
}

export default config;
